class Communities {
	constructor(nav) {
		this.nav = nav;
		this.communities = [];
		this.searchDialog = null;

		this.joinDialog = null;
		this.newSearch = true;
	}

	getCommunity(id) {
		for (let c of this.communities) {
			if (c.id == id) return c;
		}
		return null;
	}

	add(community) {
		this.communities.push(community);
	}

	pickerRows() {
		const rows = [
			UI.div('flex w-full items-center px-3 py-1 text-xs font-semibold text-zinc-500', [
				UI.span('flex-1', _('Communities')),
				this.nav.userPermissions.can(Permissions.JOIN_COMMUNITIES)
					? UI.secIconBtn('plus-square', 20, { 'click': this.createOrJoin.bind(this) })
					: null
			])
		];
		for (const community of this.communities) {
			rows.push(UI.popupItem(
				[
					UI.span('flex-none px-3', UI.icon('community', 20)),
					UI.span('flex-1 px-3', community.name),
					community.inherited
						? UI.loadTip(UI.span('flex-none px-1', UI.icon('inherited', 18), null, {
							'aria-label': 'You have access to the community because you are a guardian of a member',
							'data-tip': 'right'
						}))
						: null
				],
				{ 'click': () => this.nav.selectUnit(Nav.COMMUNITY, community.id) }
			));
		}
		return rows;
	}

	createOrJoin() {
		if (this.searchDialog == null) {
			this.info = UI.div('p-3', [
				UI.p('', _('Enter the name for the community you would like to join or create.')),
				UI.p('', _('You can create a private community, event if a public one with the same name exists.'))
			]);

			this.searchResults = UI.div('p-3', [UI.div('flex gap-3', [
				UI.btn(
					'flex-1 h-28 text-sm border rounded-md',
					_("Create New <br/> Public Community"),
					{ 'click': this.create.bind(this, true) }
				),
				UI.btn(
					'flex-1 h-28 text-sm border rounded-md',
					_("Create New <br/> Private Community"),
					{ 'click': this.create.bind(this, false) }
				)
			]), this.searchRows = UI.div('pt-3 divide')]);

			this.searchDialog = Dialog.Modal('community-search', _('Join or Create a Community'), LARGE);
			this.searchDialog.body = [
				UI.div('flex items-end', [
					UI.div('flex-1 p-1', [
						UI.label('Name'),
						this.searchName = UI.text(null, {
							'keyup': this.findCommunities.bind(this)
						}, {
							'placeholder': "Search community name"
						})
					]),
					UI.div('flex-0 p-1', UI.priBtn(_('Search'), {
						'click': this.findCommunities.bind(this)
					}))
				]),
				UI.htm('hr'),
				this.searchOutput = UI.div('', this.info)
			];
		}
		else {
			this.searchOutput.replaceChild(this.info, this.searchResults);
			this.searchName.value = '';
			this.newSearch = true;
		}
		this.searchDialog.open();
		this.searchName.select();
	}

	findCommunities() {
		API.fetch('communities', {
			name: this.searchName.value,
		})
		.then(reply => {
			showError(reply);
			if (Array.isArray(reply)) {
				if (this.newSearch) {
					this.newSearch = false;
					this.searchOutput.replaceChild(this.searchResults, this.info);
				}
				this.searchRows.innerHTML = '';
				for (let item of reply) {
					this.searchRows.appendChild(Community.fromData(item, this).searchRow);
				}
			}
		})
	}

	create(isPublic) {
		API.insert(
			'communities',
			{
				name: this.searchName.value,
				isPublic: isPublic
			}
		)
		.then(reply => {
			if (showError(reply)) return;
			window.location.replace('/members?community='+reply.id);
		});
	}

	accept(community) {
		API.insert(
			'communities/accept',
			{
				community: community.id
			}
		)
		.then(reply => {
			showError(reply);
		});
	}

	join(community) {
		if (this.joinDialog === null) {
			this.joinDialog = Dialog.Modal('joinCommunity', 'Join a community', MEDIUM, 'SEND', [
				UI.div('', [
					UI.p('', 'You may include a message with you join request'),
					UI.span('', 'Message:'),
					this.message = UI.area('')
				])
			]);
		}
		else {
			this.message.value = '';
		}

		this.joinCommunity = community;
		this.searchDialog.close();
		this.joinDialog.open(
			() => this.sendJoinRequest()
		);
	}

	sendJoinRequest() {
		API.insert(
			'communities/join',
			{
				community: this.joinCommunity.id,
				message: this.message.value
			}
		)
		.then(reply => {
			showError(reply);
		});
	}
}

class Community {
	static fromData(data, parent) {
		let inst = new Community(parent);
		inst.id = data.unit_id;
		inst.name = data.unit_name;
		inst.memberStatus = data.member_status;
		inst.memberPermission = new MemberPermission(null, data.member_permission, Nav.COMMUNITY);
		inst.inherited = data.inherited;
		inst.params = new URLSearchParams(`community=${inst.id}`);
		return inst;
	}

	constructor(parentList) {
		this.parentList = parentList;
		this.id = null;
		this.name = null;
		this.memberStatus = 0;
		this.memberPermission = null;
		this.inherited = 0;

	}

	get isGuardian() {
		return false;
	}

	get isAdmin() {
		return this.memberCan(MemberPermission.ADMIN);
	}

	memberCan(perm) {
		return this.memberPermission.can(perm);
	}

	urlForPage(page) {
		switch (page) {
			case 'layers':
				return this.memberCan(MemberPermission.VIEW_ACTIVITIES) ? `/layers?${this.params}` : null;
			case 'resources':
				return this.memberCan(MemberPermission.VIEW_RESOURCES) ? `/resources?${this.params}` : null;
			case 'graphics':
				return this.memberCan(MemberPermission.VIEW_GRAPHICS) ? `/graphics?${this.params}` : null;
			case 'details':
				return this.memberCan(MemberPermission.ADMIN) ? `/details?${this.params}` : null;
			case 'licences':
				return this.memberCan(MemberPermission.ADMIN) ? `/licences?${this.params}` : null;
			case 'members':
				return `/members?${this.params}`;
			default:
				return null;
		}
	}

	getNavLinks() {
		return [
			this.memberCan(MemberPermission.VIEW_ACTIVITIES)
				? Nav.linkRow('layers', _('Layers'), `/layers?${this.params}`) : null,
			this.memberCan(MemberPermission.VIEW_RESOURCES)
				? Nav.linkRow('resources', _('Resources'), `/resources?${this.params}`) : null,
			this.memberCan(MemberPermission.VIEW_GRAPHICS)
				? Nav.linkRow('graphics', _('Graphics'), `/graphics?${this.params}`) : null,
			this.memberCan(MemberPermission.ADMIN)
				? Nav.linkRow('details', _('Details'), `/details?${this.params}`) : null,
			// TEMPORARY: licence navigation hidden, do not remove from codebase
			// this.memberCan(MemberPermission.ADMIN)
			// 	? Nav.linkRow('licences', _('Licences'), `/licences?${this.params}`) : null,
			Nav.linkRow('members', _('Members'), `/members?${this.params}`)
		];
	}

	get joinButton() {
		switch (this.memberStatus){
			case Member.PENDING: return 'Request pending';
			case Member.INVITED: return UI.priBtn(_('Accept invite'), {'click': () => this.parentList.accept(this)});
			case Member.ACTIVE: return 'Already a member';
			default: UI.priBtn(_('JOIN'), {'click': () => this.parentList.join(this)});
		}
	}

	get searchRow() {
		return UI.div(
			'flex p-3 gap-3 items-center border-b-',
			[
				UI.div(
					'flex-1',
					this.name
				),
				UI.div(
					'flex=0',
					this.memberStatus ? 'Already a member' : UI.priBtn(_('JOIN'), {
						'click': () => this.parentList.join(this)
					})
				)
			]
		);
	}

	leave() {

	}

	delete() {

	}
}